import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {
    AddServiceRequestVehicleGQL,
    CreateServiceRequestHelperInput, CreateServiceRequestVehicleInput,
    FinishServiceRequestGQL,
    InspectServiceRequestEquipmentInput,
    InspectServiceRequestGQL,
    InspectServiceRequestInput,
    InspectServiceRequestServiceInput,
    ServiceRequest,
    ServiceRequestEquipment,
    ServiceRequestGQL,
    ServiceRequestHelper,
    ServiceRequestInspect,
    ServiceRequestInspectionGQL,
    ServiceRequestInspectionQuery,
    ServiceRequestQuery, ServiceRequestVehicle,
    UpdateServiceRequestDetailGQL,
    UpdateServiceRequestDetailInput
} from '../../../../generated/graphql';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {QueryRef} from 'apollo-angular';
import {BaseComponent} from '../../../base/base.component';
import moment from 'moment';
import {UserService} from '../../../service/user.service';

declare var $: any;

@Component({
    selector: 'app-services-survey',
    templateUrl: './services-survey.component.html',
    styleUrls: ['./services-survey.component.scss']
})
export class ServicesSurveyComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('entryInput') entryInputRef: ElementRef;
    @ViewChild('exitInput') exitInputRef: ElementRef;

    @ViewChild('entryInputEdit') entryInputEdit: ElementRef;
    @ViewChild('exitInputEdit') exitInputEdit: ElementRef;


    window = window;
    paramId = '';
    paramSub = '';
    model: ServiceRequest = new ServiceRequest();
    modelUpdate: ServiceRequest = new ServiceRequest();
    modelQuery: QueryRef<ServiceRequestQuery>;
    modelInspectQuery: QueryRef<ServiceRequestInspectionQuery>;
    flagEdit = false;
    flagFinish = false;
    flagSignature = false;

    // P4.1: costura de modo entrada/saída. O status 'check' morreu na 2b (o back
    // não gera mais esse status), então o modo NÃO pode mais derivar do status.
    // Nesta fatia selectedVehicle fica SEMPRE null (o seletor é a P4.2) → surveyMode
    // é sempre 'entry' → comportamento visível idêntico ao de hoje.
    selectedVehicle: any = null;
    // P4.5: reabertura/edição. Quando editando uma vistoria existente, o MODO é o
    // type ORIGINAL da inspect (a edição não muda a natureza da vistoria), não o
    // derivado do state do veículo.
    editingInspectId: string = null;
    editingType: 'entry' | 'exit' = null;
    get surveyMode(): 'entry' | 'exit' {
        // Visualização :sub (read-only): o modo é o TYPE da inspect carregada
        // (getInspection seta modelInspect.type = a.type, que já vem 'entry'/'exit'),
        // não o state atual do veículo (null em :sub).
        if (!this.isNullOrUndefined(this.paramSub)) {
            return this.modelInspect?.type === 'exit' ? 'exit' : 'entry';
        }
        if (this.editingInspectId) return this.editingType === 'exit' ? 'exit' : 'entry';
        return this.selectedVehicle?.state === 'in' ? 'exit' : 'entry';
    }
    imageSignature = undefined;
    imageSignatureFile: File;

    helper: ServiceRequestHelper = new ServiceRequestHelper();
    vehicle: ServiceRequestVehicle = new ServiceRequestVehicle();

    quantity = 0;
    arrItems: InspectServiceRequestEquipmentInput[] = [
        {name: 'Aspirador de pó', quantity: 0},
        {name: 'Balometro', quantity: 0},
        {name: 'Cabos, tomadas, e diversos', quantity: 0},
        {name: 'Carrinho', quantity: 0},
        {name: 'Carro oficina', quantity: 0},
        {name: 'Chave catraca kit', quantity: 0}
    ];
    modelInspect: InspectServiceRequestInput = new InspectServiceRequestInput();

    modelEquipament: ServiceRequestEquipment[] = [];
    modelEquipamentInspections: any[] = [];
    // P4.3: lista de itens que SAEM neste veículo, derivada do pool remanescente
    // (model.pool). quantity começa em 0; max = remaining do item (teto do +/-).
    modelExit: { name: string; quantity: number; max: number }[] = [];
    // P4.6: form do "+ veículo" (portaria).
    newVehicle: { vehicle: string; licensePlate: string } = { vehicle: '', licensePlate: '' };
    modelEquipamentInspectionsObj: any = {};
    modelImspectFilter: ServiceRequestInspect[] = [];

    fileEquipment: File = null;
    thumbEquipment: any = null;

    modelInspectOthers = undefined;
    modelInspectObs = undefined;
    modelIsFinalize: boolean;
    canvas: any;
    ctx: any;

    editableInput = false;
    selectedHelper!: ServiceRequestHelper;

    constructor(public router: Router,
                public activatedRoute: ActivatedRoute,
                public translate: TranslateService,
                private userService: UserService,
                private serviceRequestGQL: ServiceRequestGQL,
                private serviceRequestInspectionGQL: ServiceRequestInspectionGQL,
                private updateServiceRequestDetailGQL: UpdateServiceRequestDetailGQL,
                private finishServiceRequestGQL: FinishServiceRequestGQL,
                private addServiceRequestVehicleGQL: AddServiceRequestVehicleGQL,
                private inspectServiceRequestGQL: InspectServiceRequestGQL) {
        super(router, translate);
        this.model.helper = [];
        // this.model.vehicles = [];
        this.modelInspect.serviceRequest = new InspectServiceRequestServiceInput();
    }

    ngOnInit(): void {
        $(() => {
            $('#downArrow').click(() => {
                $('#downDiv').slideToggle('slow');
            });
        });

        this.enableDatePickers();
    }

    enableDatePickers() {
        $(() => {
            this.setDatePicker('date-picker-entry', (start, end, label) => {
                this.helper.entryDate = start.utcOffset(0, true).toISOString();
            }, this.helper.entryDate, true, 'DD/MM/YYYY [às] HH:mm', true);

            const exitDate = this.helper.departureDate && moment(this.helper.departureDate).isValid()
                ? this.helper.departureDate
                : undefined;

            this.setDatePicker('date-picker-exit', (start, end, label) => {
                this.helper.departureDate = start.utcOffset(0, true).toISOString();
            }, exitDate, true, 'DD/MM/YYYY [às] HH:mm', true);

            if (!exitDate) {
                $('.date-picker-exit').val('');
            }
        });
    }

    ngAfterViewInit(): void {
        this.activatedRoute.params.subscribe(u => {
            if (!this.isNullOrUndefined(u.id)) {
                console.log(u);
                this.paramId = u.id;
                this.paramSub = !this.isNullOrUndefined(u.sub) ? u.sub : '';
                this.modelQuery = this.serviceRequestGQL.watch({data: this.paramId});
                this.modelQuery.valueChanges.subscribe(({data}) => {
                    this.model = data.serviceRequest as ServiceRequest;
                    // console.log('MODEL SERVICE REQUEST', this.model)
                    this.modelEquipament = data.serviceRequest.virtualEquipment as ServiceRequestEquipment[];
                    this.getFilterInspect();
                    this.thumbEquipment = this.model.inspect[0]?.equipmentImage;
                    // P4.1: o ramo 'check' está morto (2b não gera mais esse
                    // status). Preserva a intenção real: só bloqueia edição em
                    // 'finished'. Equivalente aos casos vivos (inspect→true,
                    // finished→false); a visualização de :sub continua read-only
                    // via getInspection() logo abaixo (flagEdit=false).
                    this.flagEdit = this.model.status !== 'finished';
                    if (!this.isNullOrUndefined(this.paramSub)) {
                        this.getInspection();
                    }
                    // else {
                    //     if (this.model.inspect[0]) {
                    //         this.model.inspect[0]?.equipment.map((x) => {
                    //             const el = this.model.virtualEquipment.filter((f) => f.name === x.name);
                    //             el[0].quantity = x.quantity;
                    //         });
                    //     }
                    // }
                });
            }
            // $(() => {
            //     this.canvas = document.getElementById('sig-canvas');
            //     this.ctx = this.canvas.getContext('2d');
            //     this.handlerPaint();
            //     $(window).resize(() => {
            //         let W = this.canvas.offsetWidth, H = this.canvas.offsetHeight;
            //         let temp = this.ctx.getImageData(0, 0, W, H)
            //         this.ctx.canvas.width = parseInt(document.getElementById('sketch').offsetWidth.toString(), 0);
            //         this.ctx.canvas.height = parseInt(document.getElementById('sketch').offsetHeight.toString(), 0);
            //         this.ctx.putImageData(temp, 0, 0)
            //     })
            // });
        });
    }

    // actionSignature(isFinish?) {
    //     if (this.flagFinish) {
    //         return;
    //     }
    //     let a = 0;
    //     const b = $('html, body');
    //     b.toggleClass('no-scroll');
    //     this.flagSignature = !this.flagSignature;
    //     if (!this.flagSignature) {
    //         a = $('.signature').offset().top;
    //     }
    //     b.stop().animate({ scrollTop: a });
    //     this.toggleFullScreen();
    // }

    // handlerPaint() {
    //     $(() => {
    //         const st = this;
    //         this.canvas.width = parseInt(document.getElementById('sketch').offsetWidth.toString(), 0);
    //         this.canvas.height = parseInt(document.getElementById('sketch').offsetHeight.toString(), 0);
    //
    //         // Get a regular interval for drawing to the screen
    //         window.requestAnimFrame = (function (callback) {
    //             return window.requestAnimationFrame ||
    //                 window.webkitRequestAnimationFrame ||
    //                 window.mozRequestAnimationFrame ||
    //                 window.oRequestAnimationFrame ||
    //                 window.msRequestAnimaitonFrame ||
    //                 function (callback) {
    //                     window.setTimeout(callback, st.canvas.width / st.canvas.height);
    //                 };
    //         })();
    //
    //         this.ctx.strokeStyle = '#222222';
    //         this.ctx.lineWith = 2;
    //
    //         // Set up the UI
    //         const sigText: any = document.getElementById('sig-dataUrl');
    //         const sigImage: any = document.getElementById('sig-image');
    //         const clearBtn: any = document.getElementById('sig-clearBtn');
    //         const submitBtn: any = document.getElementById('sig-submitBtn');
    //         clearBtn.addEventListener('click', function (e) {
    //             clearCanvas();
    //             // sigText.innerHTML = 'Data URL for your signature will go here!';
    //             // sigImage.setAttribute('src', '');
    //         }, false);
    //         submitBtn.addEventListener('click', function (e) {
    //             const dataUrl = st.canvas.toDataURL('image/png');
    //             const blobBin = atob(dataUrl.split(',')[1]);
    //             const array = [];
    //             for (let i = 0; i < blobBin.length; i++) {
    //                 array.push(blobBin.charCodeAt(i));
    //             }
    //             st.imageSignatureFile = new File([new Uint8Array(array)], 'signature.png', {
    //                 type: 'image/png',
    //                 lastModified: new Date().getTime()
    //             });
    //             st.imageSignature = dataUrl;
    //             st.actionSignature();
    //         }, false);
    //         // Set up mouse events for drawing
    //         let drawing = false;
    //         let mousePos = {x: 0, y: 0};
    //         let lastPos = mousePos;
    //         this.canvas.addEventListener('mousedown', function (e) {
    //             // st.flagSignature = true; // FLAG ASSINATURA PREENCHIDA
    //             drawing = true;
    //             lastPos = getMousePos(st.canvas, e);
    //         }, false);
    //         this.canvas.addEventListener('mouseup', function (e) {
    //             drawing = false;
    //         }, false);
    //         this.canvas.addEventListener('mousemove', function (e) {
    //             mousePos = getMousePos(st.canvas, e);
    //         }, false);
    //         // Set up touch events for mobile, etc
    //         this.canvas.addEventListener('touchstart', function (e) {
    //             mousePos = getTouchPos(st.canvas, e);
    //             const touch: any = e.touches[0];
    //             const mouseEvent: any = new MouseEvent('mousedown', {
    //                 clientX: touch.clientX,
    //                 clientY: touch.clientY
    //             });
    //             st.canvas.dispatchEvent(mouseEvent);
    //         }, false);
    //         this.canvas.addEventListener('touchend', function (e) {
    //             const mouseEvent: any = new MouseEvent('mouseup', {});
    //             st.canvas.dispatchEvent(mouseEvent);
    //         }, false);
    //         this.canvas.addEventListener('touchmove', function (e) {
    //             const touch: any = e.touches[0];
    //             const mouseEvent: any = new MouseEvent('mousemove', {
    //                 clientX: touch.clientX,
    //                 clientY: touch.clientY
    //             });
    //             st.canvas.dispatchEvent(mouseEvent);
    //         }, false);
    //         // Prevent scrolling when touching the canvas
    //         document.body.addEventListener('touchstart', function (e) {
    //             if (e.target === st.canvas) {
    //                 e.preventDefault();
    //             }
    //         }, false);
    //         document.body.addEventListener('touchend', function (e) {
    //             if (e.target === st.canvas) {
    //                 e.preventDefault();
    //             }
    //         }, false);
    //         document.body.addEventListener('touchmove', function (e) {
    //             if (e.target === st.canvas) {
    //                 e.preventDefault();
    //             }
    //         }, false);
    //
    //         // Get the position of the mouse relative to the canvas
    //         function getMousePos(canvasDom, mouseEvent) {
    //             const rect = canvasDom.getBoundingClientRect();
    //             return {
    //                 x: mouseEvent.clientX - rect.left,
    //                 y: mouseEvent.clientY - rect.top
    //             };
    //         }
    //
    //         // Get the position of a touch relative to the canvas
    //         function getTouchPos(canvasDom, touchEvent) {
    //             const rect = canvasDom.getBoundingClientRect();
    //             return {
    //                 x: touchEvent.touches[0].clientX - rect.left,
    //                 y: touchEvent.touches[0].clientY - rect.top
    //             };
    //         }
    //
    //         // Draw to the canvas
    //         function renderCanvas() {
    //             if (drawing) {
    //                 st.ctx.moveTo(lastPos.x, lastPos.y);
    //                 st.ctx.lineTo(mousePos.x, mousePos.y);
    //                 st.ctx.stroke();
    //                 lastPos = mousePos;
    //             }
    //         }
    //
    //         function clearCanvas() {
    //             st.canvas.width = st.canvas.width;
    //         }
    //
    //         // Allow for animation
    //         (function drawLoop() {
    //             requestAnimFrame(drawLoop);
    //             renderCanvas();
    //         })();
    //     });
    // }

    getInspection() {
        this.modelInspectQuery = this.serviceRequestInspectionGQL.watch({data: this.paramSub});
        this.modelInspectQuery.valueChanges.subscribe(({data}) => {
            const a = data.serviceRequestInspection;
            this.modelEquipamentInspections = a.equipment as any;
            this.modelEquipamentInspectionsObj = a as any;
            if(!this.isNullOrUndefined(this.modelEquipamentInspectionsObj.obs)){
               this.modelInspectObs = this.modelEquipamentInspectionsObj.obs;
            }
            this.flagEdit = false;
            this.flagFinish = true;
            this.imageSignature = a.signature;
            if (a) {
                this.modelInspect.type = a.type;
                this.modelInspect.others = a.others;
                if (this.model.status === 'finished') {
                    this.modelEquipament = a.equipment;
                }
            }
        });
    }

    dropCol() {
        // $('.col_hide').toggleClass('d-none');
        $('.col_hide').stop().slideToggle();
        $('#downArrow').toggleClass('rotate');
    }

    handlerItemQuantity(t: string, x: any) {
        // P4.3: na SAÍDA respeita o teto (x.max = remaining do pool), piso 0.
        if (this.surveyMode === 'exit') {
            if (t === 'add') {
                if (x.quantity < x.max) x.quantity++;
            } else {
                x.quantity = x.quantity <= 0 ? 0 : x.quantity - 1;
            }
            return;
        }
        // ENTRADA: comportamento atual (sem teto).
        if (t === 'add') {
            x.quantity++;
        } else {
            x.quantity = x.quantity <= 1 ? 0 : x.quantity - 1;
        }
    }

    // P4.3: ao trocar o veículo no seletor, recomputa a lista de saída. Como o
    // pool é do SERVIÇO (não por veículo), a lista é a mesma; recomputar zera as
    // quantidades (contagem nova a cada troca).
    onSelectedVehicleChange(v: any) {
        this.selectedVehicle = v;
        this.ensureExitList();
    }

    // P4.6: abre o modal do "+ veículo" com o form limpo.
    openAddVehicle() {
        this.newVehicle = { vehicle: '', licensePlate: '' };
        this.showModal('addVehicle');
    }

    // P4.6: cadastra 1 veículo (portaria). Valida placa+descrição; no sucesso
    // refetch (repovoa vehicles/pool) SEM auto-selecionar; o back gateia o perfil.
    addVehicle() {
        const plate = (this.newVehicle.licensePlate || '').trim();
        const desc = (this.newVehicle.vehicle || '').trim();
        if (!plate || !desc) {
            return this.showMessage(this.translate.instant('atencao'),
                this.translate.instant('preenchaplacaedescricao'), 'warning');
        }
        this.addServiceRequestVehicleGQL.mutate({
            data: { serviceRequestId: this.paramId, vehicle: desc, licensePlate: plate },
        }).subscribe(() => {
            this.closeModal('addVehicle');
            this.modelQuery.refetch();
            super.showMessage(this.translate.instant('success'),
                this.translate.instant('veiculoadicionado'), 'success');
        }, error => super.onError(error));
    }

    // P4.3: monta modelExit a partir do pool remanescente. Itens com remaining 0
    // são OMITIDOS (não há o que retirar deles). Pool vazio → lista vazia (não
    // quebra; permite salvar saída sem itens — apenas registra a saída do veículo).
    ensureExitList() {
        this.modelExit = (this.model?.pool ?? [])
            .filter((p) => (p.remaining ?? 0) > 0)
            .map((p) => ({ name: p.name, quantity: 0, max: p.remaining }));
    }

    // P4.5: abre a edição de uma vistoria do log. Usa o próprio item de
    // model.inspect (id/type/vehicleId/equipment já vêm no fragment) — NÃO usa
    // serviceRequestInspection (que, p/ saída, devolve a ENTRADA anterior).
    editInspect(x: any) {
        this.editingInspectId = x.id;
        this.editingType = x.type === 'exit' ? 'exit' : 'entry';
        // veículo da vistoria (casa o seletor; o modo já vem do editingType).
        this.selectedVehicle = (this.model.vehicles ?? []).find((v) => v.id === x.vehicleId) ?? null;
        this.modelInspectObs = x.obs ?? undefined;
        this.modelInspectOthers = x.others ?? undefined;
        if (this.editingType === 'exit') {
            this.buildExitEditList(x);
        } else {
            this.buildEntryEditList(x);
        }
    }

    // P4.5 (ENTRADA em edição): catálogo (virtualEquipment) com as quantidades JÁ
    // registradas nesta inspect pré-preenchidas. Muta o MESMO array que
    // onCreateInspection lê no push da entrada.
    buildEntryEditList(x: any) {
        const own = new Map<string, number>((x.equipment ?? []).map((e) => [e.name, e.quantity]));
        (this.model.virtualEquipment ?? []).forEach((c: any) => {
            c.quantity = own.get(c.name) ?? 0;
        });
        this.modelEquipament = this.model.virtualEquipment as any;
    }

    // P4.5 (SAÍDA em edição): teto = pool.remaining + o que ESTA saída já tinha,
    // porque o back exclui a própria inspect do saldo (getPool(service,
    // excludeInspectId)) — os itens desta saída "voltam" ao pool. quantity inicial
    // = o que a saída já retirava.
    buildExitEditList(x: any) {
        const own = new Map<string, number>((x.equipment ?? []).map((e) => [e.name, e.quantity]));
        const pool = this.model?.pool ?? [];
        const names = new Set<string>([...pool.map((p) => p.name), ...own.keys()]);
        this.modelExit = [...names]
            .map((name) => {
                const rem = pool.find((p) => p.name === name)?.remaining ?? 0;
                const ownQty = own.get(name) ?? 0;
                return { name, quantity: ownQty, max: rem + ownQty };
            })
            .filter((it) => it.max > 0);
    }

    // P4.5: sai do modo edição sem salvar; volta ao estado normal.
    cancelEdit() {
        this.editingInspectId = null;
        this.editingType = null;
        this.selectedVehicle = null;
        (this.model.virtualEquipment ?? []).forEach((c: any) => (c.quantity = 0));
        this.modelExit = [];
        this.modelInspectObs = undefined;
        this.modelInspectOthers = undefined;
    }

    // P4.2: veículo obrigatório só quando há veículo SELECIONÁVEL (linha filha
    // com id). Serviços sem veículos, ou legado só com coluna embutida (id null),
    // não exigem seleção — espelha o gate do back.
    get requiresVehicle(): boolean {
        return (this.model?.vehicles ?? []).some((v) => !!v.id);
    }

    // BUG2: placa do veículo da vistoria em visualização (:sub). Resolve pela
    // PRÓPRIA inspect (model.inspect por id), não pelo serviceRequestInspection
    // (que, p/ saída, devolve a ENTRADA anterior). Legado sem veículo → '-'.
    get detailVehicleLabel(): string {
        if (this.isNullOrUndefined(this.paramSub)) { return ''; }
        const insp = (this.model?.inspect ?? []).find((i) => i.id === this.paramSub);
        const v = (this.model?.vehicles ?? []).find((vv) => vv.id === (insp as any)?.vehicleId);
        return v?.licensePlate || '-';
    }

    actionSave() {
        // if (!this.validateSaveRequest()) {
        //     return false;
        // }
        // P4.2: bloqueia a vistoria sem veículo quando o serviço exige.
        if (this.requiresVehicle && !this.selectedVehicle) {
            return this.showMessage(this.translate.instant('atencao'),
                this.translate.instant('selecioneveiculovistoria'), 'warning');
        }
        this.confirmMessage(this.translate.instant('atencao'), this.translate.instant('temcertezadesejaprosseguir'), () => {
            this.onCreateInspection();
        });
    }

    // Fatia 2c: só habilita encerrar quando todos os veículos estão fora.
    get allVehiclesOut(): boolean {
        return (this.model?.vehicles ?? []).every((v) => v.state !== 'in');
    }

    actionFinish() {
        // Fatia 2c: encerramento manual via mutation dedicada (não mais isFinalize).
        // Gate no front (espelha o gate do back: perfil + todos os veículos fora).
        if (!this.allVehiclesOut) {
            return this.showMessage(this.translate.instant('atencao'),
                this.translate.instant('veiculodentroaviso'), 'warning');
        }
        this.confirmMessage(this.translate.instant('atencao'), this.translate.instant('desejarealmenteencerrar'), () => {
            this.finishServiceRequestGQL.mutate({id: this.paramId}).subscribe((result) => {
                // P4.4: o encerramento JÁ ocorreu (back setou finished). Se sobrou
                // item no pool, apenas AVISA (não bloqueia); senão sucesso normal.
                const leftover = result?.data?.finishServiceRequest?.leftover ?? [];
                this.router.navigate(['/services']);
                if (leftover.length > 0) {
                    const itens = leftover.map((l) => `${l.name} (${l.remaining})`).join(', ');
                    super.showMessage(this.translate.instant('atencao'),
                        this.translate.instant('servicoencerradosobra', {itens}), 'warning');
                } else {
                    super.showMessage(this.translate.instant('success'), this.translate.instant('Servicoalteradocomsucesso'), 'success');
                }
            }, error => super.onError(error));
        });
    }

    // validateSaveRequest() {
    //     let str = true;
    //     if (this.isNullOrUndefined(this.imageSignatureFile)) {
    //         super.showMessage(this.translate.instant('atencao'),
    //             this.translate.instant('assinerequisiçaoparaprosseguir'), 'warning');
    //         str = false;
    //     }
    //     return str;
    // }

    onCreateInspection() {
        this.modelInspect = new InspectServiceRequestInput();
        this.modelInspect.serviceRequest = {id: this.paramId};
        this.modelInspect.equipment = [];
        if (this.surveyMode === 'exit') {
            // P4.3: SAÍDA — empurra só os itens marcados no pool (quantity>0).
            this.modelExit
                .filter((e) => e.quantity > 0)
                .forEach((e) => {
                    this.modelInspect.equipment.push({name: e.name, quantity: e.quantity});
                });
        } else if (this.model.status !== 'finished' && this.model.status !== 'expired') {
            // P4.1/P4.2: ENTRADA — empurra o catálogo (virtualEquipment). Borda:
            // expired/finished NÃO empurram (preserva o comportamento antigo).
            this.model.virtualEquipment.forEach((e) => {
                this.modelInspect.equipment.push({name: e.name, quantity: e.quantity});
            });
        }
        this.modelInspect.others = this.modelInspectOthers;
        this.modelInspect.obs = this.modelInspectObs;
        this.modelInspect.isFinalize = this.modelIsFinalize;
        this.modelInspect.date = moment();
        // P4.1: modo pela costura (antes: status==='check').
        this.modelInspect.type = this.surveyMode === 'exit' ? 'exit' : 'entry';
        // P4.2: veículo escolhido no seletor vai no payload. Se nenhum foi
        // escolhido (selectedVehicle null), vehicleId fica undefined → vistoria
        // sem veículo (legado; o back aceita nullable).
        this.modelInspect.vehicleId = this.selectedVehicle?.id;
        // P4.5: em edição, manda o id da PRÓPRIA vistoria → o back substitui só os
        // itens dela e exclui a própria inspect da validação de saldo. type/vehicleId
        // preservados (o modo vem do editingType).
        if (this.editingInspectId) this.modelInspect.id = this.editingInspectId;
        // console.log('this.modelInspect');
        // console.log(this.modelInspect);
        this.inspectServiceRequestGQL.mutate({data: this.modelInspect}).subscribe((result) => {
            this.editingInspectId = null;
            this.editingType = null;
            this.onCreateImage(result.data.inspectServiceRequest);
        });
        this.modelIsFinalize = false;
    }

    onCreateImage(o: any) {
        // this.userService.uploadFile(this.imageSignatureFile, `/upload/service-request/inspect/${o.id}/signature`).subscribe({
        //     next: data => {
                this.userService.uploadFile(this.fileEquipment, `/upload/service-request/inspect/${o.id}/equip-image`).subscribe({
                    next: data => {
                    }, error: err => super.onError(err)
                });
                this.router.navigate(['/services']);
                super.showMessage(this.translate.instant('success'), this.translate.instant('Servicoalteradocomsucesso'), 'success');
            }
        // });

    pushHelpersList() {
        const entryDateStr = this.entryInputRef.nativeElement.value;
        const exitDateStr = this.exitInputRef.nativeElement.value;

        const entryDate = moment(entryDateStr, 'DD/MM/YYYY [às] HH:mm', true);
        const exitDate = moment(exitDateStr, 'DD/MM/YYYY [às] HH:mm', true);

        // console.log('HELPER NO PUSH HELPER', this.helper);

        if (!entryDate.isValid()) {
            return this.showMessage(
                this.translate.instant('baseComponent.warningAttention'),
                this.translate.instant('form'),
                'warning'
            );
        }

        this.helper.entryDate = entryDate.utcOffset(0).toISOString();
        this.helper.departureDate = exitDate.utcOffset(0).toISOString();

        if (
            this.isNullOrUndefined(this.helper.name) ||
            this.isNullOrUndefined(this.helper.doc)
        ) {
            return this.showMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('form'), 'warning');
        }
        this.modelUpdate.helper.push(this.helper);
        this.helper = new ServiceRequestHelper();
    }

    removeHelpers(memberId: string, index: number) {
        super.confirmMessage('Atenção', 'Deseja realmente excluir esse ajudante?', () => {
            this.modelUpdate.helper.splice(index, 1);
        });
    }

    editProvider() {
        this.modelUpdate = new ServiceRequest();
        this.modelUpdate = JSON.parse(JSON.stringify(this.model)) as ServiceRequest;
        this.showModal('updateProvider');
    }

    saveProvider() {
        const arrValidateFields = [
            {value: this.modelUpdate.name, text: `Nome do prestador<br>`},
            // {value: this.modelUpdate.licensePlate, text: `RG<br>`},
            // {value: this.modelUpdate.vehicle, text: `Placa do Veículo<br>`},
            // {value: this.modelUpdate, text: `Veículo<br>`},
        ];

        const stringError = this.validateField(arrValidateFields);

        if (!super.isNullOrUndefined(stringError)) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), `${this.translate.instant('camposobrigatorios')} <br> ${stringError}`);
            return;
        }

        let helpers: CreateServiceRequestHelperInput[] = [];
        this.modelUpdate.helper.forEach((e) => {
            helpers.push({
                name: e.name,
                doc: e.doc,
                entryDate: e.entryDate,
                departureDate: e.departureDate
            });
        });

        let vehicles: CreateServiceRequestVehicleInput[] = [];
        this.modelUpdate.vehicles.forEach((v) => {
            vehicles.push({
                // Fatia 2a: envia o id das linhas existentes (do fragment) para
                // preservar os ids no update aditivo; veículos novos vão sem id.
                id: v.id,
                vehicle: v.vehicle,
                licensePlate: v.licensePlate
            });
        });

        const data: UpdateServiceRequestDetailInput = {
            id: this.modelUpdate.id,
            name: this.modelUpdate.name,
            // licensePlate: this.modelUpdate.licensePlate,
            // vehicle: this.modelUpdate.vehicle,
            vehicles: vehicles,
            helper: helpers,
        };
        this.updateServiceRequestDetailGQL.mutate({data}).subscribe(({data}) => {
            this.closeModal('updateProvider');
            this.modelQuery.refetch({data: this.paramId});
            super.showMessage(this.translate.instant('success'), this.translate.instant('Servicoalteradocomsucesso'), 'success');
        }, error => super.onError(error));
    }

    setCroppedEquipment(o: any) {
        this.thumbEquipment = o.thumb;
        this.fileEquipment = this.handleUpload(o.file);
    }

    getFilterInspect() {
        this.modelImspectFilter = this.model.inspect.filter(e => !super.isNullOrUndefined(e.others));
    }

    pushVehicleList() {
        // console.log('MODEL UPDATE', this.modelUpdate);
        // console.log('VEHICLE', this.vehicle);
        this.modelUpdate.vehicles.push(this.vehicle);
        this.vehicle = new ServiceRequestVehicle();

        // if (this.isNullOrUndefined(this.vehicles) || this.isNullOrUndefined(this.vehicles.length)) {
        //     return this.showMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('form'), 'warning');
        // }
        // this.modelUpdate.vehicles.push(this.vehicle);
        // this.vehicle = new ServiceRequestVehicle();
    }

    removeVehicle(i: number) {
        super.confirmMessage('Atenção', 'Deseja realmente excluir esse veículo?', () => {
            this.modelUpdate.vehicles.splice(i, 1);
        });
    }

    editHelper(helper: ServiceRequestHelper) {
        this.selectedHelper = helper;

        // console.log('SELECTED HELPER ANTES DO MODAL', this.selectedHelper);

        this.showModal('updateHelper');

        // console.log('SELECTED HELPER DEPOIS DO MODAL', this.selectedHelper);

        const format = 'DD/MM/YYYY [às] HH:mm';

        // Saída/Entrada vazia (null/undefined/'') ou inválida deve vir preenchida
        // com a data/hora corrente (vigilante abre o modal para registrar a saída
        // agora), nunca "Data inválida". Mesmo padrão "agora" (moment()) usado no
        // restante do componente. Valor real existente é preservado.
        const parsedEntry = moment(this.selectedHelper.entryDate);
        const parsedExit = moment(this.selectedHelper.departureDate);

        const entryDate = (this.selectedHelper.entryDate && parsedEntry.isValid()) ? parsedEntry : moment();
        const exitDate = (this.selectedHelper.departureDate && parsedExit.isValid()) ? parsedExit : moment();

        this.entryInputEdit.nativeElement.value = entryDate.format(format);
        this.exitInputEdit.nativeElement.value = exitDate.format(format);


    }

    onUpdateHelper() {
        const modifiedEntry = this.entryInputEdit.nativeElement.value;
        const modifiedExit = this.exitInputEdit.nativeElement.value;

        // console.log('MODIFIED ENTRY DATE', this.entryInputEdit.nativeElement.value);
        // console.log('MODIFIED EXIT DATE', this.exitInputEdit.nativeElement.value);
        //
        // console.log('SELECTED HELPER NO UPDATE', this.selectedHelper);


        // this.helper.entryDate = this.selectedHelper.entryDate;
        // this.helper.departureDate = this.selectedHelper.departureDate;

        const index = this.modelUpdate.helper.findIndex(h => h.id === this.selectedHelper.id);

        // console.log('HELPER MATCH', index);

        if (index !== -1) {
            this.modelUpdate.helper[index].entryDate = moment(modifiedEntry, 'DD/MM/YYYY [às] HH:mm').toISOString();
            this.modelUpdate.helper[index].departureDate = moment(modifiedExit, 'DD/MM/YYYY [às] HH:mm').toISOString();
        }

        this.closeModal('updateHelper');
    }
}
